import http from "./client"


interface ICoursesListParams {
  group_id: number;
  limit: number;
  page: number;
}

export async function courses(params: ICoursesListParams) {
  const resp = await http.get('/panel/files/courses', {
    params
  });
  return resp.data;
}

const files = {
  courses
}

export default files